import type { StartupData } from '@workspace/api-backend'
import { useEditMode } from '../../../hooks/use-edit-mode'
import { StartupEdit } from './startup-edit'
import { StartupView } from './startup-view'

type StartupEntityProps = {
  startup: StartupData
  permissions?: { canEdit: boolean }
}

export function StartupEntity({ startup, permissions }: StartupEntityProps) {
  const { isEditMode, startEditing, stopEditing } = useEditMode()
  const canEdit = permissions?.canEdit ?? false

  if (canEdit && isEditMode) {
    return <StartupEdit onExitEdit={stopEditing} />
  }

  return <StartupView startup={startup} canEdit={canEdit} onEdit={startEditing} />
}
